// Header.jsx
import React, { useState, useEffect } from 'react';
import MainMenu from './MainMenu';
import StickyMenu from './StickyMenu';
import MobileMenu from './MobileMenu';

function Header() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [clicking, setClicking] = useState(false);
  const [hovering, setHovering] = useState(false);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
    document.body.classList.toggle("locked"); 
    setOpenDropdown(null); // Close all dropdowns when mobile nav is toggled
  };

  const toggleDropdown = (menuName) => {
    setOpenDropdown(openDropdown === menuName ? null : menuName);
  };

  useEffect(() => {
    const cursor = document.querySelector(".custom-cursor__cursor");
    const cursorinner = document.querySelector(".custom-cursor__cursor-two");

    function handleMouseMove(e) {
      const x = e.clientX;
      const y = e.clientY;
      setCursorPosition({ x, y });
    }

    function handleMouseDown() {
      setClicking(true);
      cursor.classList.add("click");
      cursorinner.classList.add("custom-cursor__innerhover");
    }

    function handleMouseUp() {
      setClicking(false);
      cursor.classList.remove("click");
      cursorinner.classList.remove("custom-cursor__innerhover");
    }

    function handleMouseOver() {
      setHovering(true);
      cursor.classList.add("custom-cursor__hover");
    }

    function handleMouseLeave() {
      setHovering(false);
      cursor.classList.remove("custom-cursor__hover");
    }

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);

    const links = document.querySelectorAll("a");
    links.forEach(item => {
      item.addEventListener("mouseover", handleMouseOver);
      item.addEventListener("mouseleave", handleMouseLeave);
    });

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
      links.forEach(item => {
        item.removeEventListener("mouseover", handleMouseOver);
        item.removeEventListener("mouseleave", handleMouseLeave);
      });
    };
  }, []);

  return (
    <div className="custom-cursor">
      <div className="custom-cursor__cursor" style={{ transform: `translate3d(calc(${cursorPosition.x}px - 50%), calc(${cursorPosition.y}px - 50%), 0)` }} />
      <div className="custom-cursor__cursor-two" style={{ left: `${cursorPosition.x}px`, top: `${cursorPosition.y}px` }} />

      <header className="main-header">
        <MainMenu toggleMobileNav={toggleMobileNav} />
      </header>

      <StickyMenu toggleMobileNav={toggleMobileNav} />

      <MobileMenu 
        isMobileNavOpen={isMobileNavOpen} 
        toggleMobileNav={toggleMobileNav}
        openDropdown={openDropdown}
        toggleDropdown={toggleDropdown}
      />

      <style jsx>{`
        // .main-menu__btn-box {
        //   position: absolute;
        //   top: 11px;
        //   bottom: 0;
        //   right: 0;
        //   background-color: #5b4034;
        //   text-align: center;
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        //   padding: 0 65.5px 0px;
        //   border-top-right-radius: var(--delogis-bdr-radius);
        //   border-bottom-right-radius: var(--delogis-bdr-radius);
        //   -webkit-transition: all 500ms ease;
        //   transition: all 500ms ease;
        //   z-index: 5;
        // }
        // .main-menu__wrapper-inner-content:after {
        //   content: "";
        //   position: absolute;
        //   top: 55px;
        //   bottom: 1px;
        //   left: 300px;
        //   right: 0;
        //   background-color: #5b4034;
        //   border-radius: var(--delogis-bdr-radius);
        //   z-index: -1;
        // }
      `}</style>
    </div>
  );
}

export default Header;